import React from 'react';
import './RequesterName.css';

/**
 * Who raised a ticket, with a small "(contractor)" after the name when a
 * contractor did.
 *
 * Since migration 064 a ticket's requester can be a contractor - a request to
 * the firm for a licence, a part, an account - and every row the API returns
 * carries `requester_name` (falling back to the contractor's name) and
 * `requester_kind` ('user' | 'contractor'). Eight screens print that name;
 * this is the one place that decides how the tag beside it looks, so a
 * contractor's request reads the same in the approvals queue, the ticket
 * list, the dashboard and on the ticket itself. The tag is text, not only
 * colour, because a reader who cannot tell the tint apart still has to know.
 *
 * `fallback` is what to print when there is no name at all; the callers that
 * used to print '—', 'unknown' or nothing keep doing so.
 */
export default function RequesterName({ ticket, fallback = '—' }) {
  const name = ticket?.requester_name;
  if (!name) return <>{fallback}</>;
  return (
    <span className="req-name">
      {name}
      {ticket.requester_kind === 'contractor' && (
        <span className="req-kind">(contractor)</span>
      )}
    </span>
  );
}

/** The same thing as plain text, for a CSV cell or a title attribute. */
export const requesterLabel = (ticket, fallback = '') => {
  const name = ticket?.requester_name;
  if (!name) return fallback;
  return ticket.requester_kind === 'contractor' ? `${name} (contractor)` : name;
};
